// firebase.js
import { initializeApp, getApps, getApp } from 'firebase/app';
import { getMessaging , getToken , onMessage } from 'firebase/messaging';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyCRfGnfcDs7tBvesdDvsRJ4L8SXyBFq5z8",
  authDomain: "dcp-test-186fb.firebaseapp.com",
  projectId: "dcp-test-186fb",
  storageBucket: "dcp-test-186fb.appspot.com",
  messagingSenderId: "158257781334",
  appId: "1:158257781334:web:5c8499ba30688ee17e39f7",
  measurementId: "G-2KVHDBJJMT"
};

const vapidKey = process.env.VUE_APP_VAPIKEY

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

// 只導出需要的功能，避免不同地方重複初始化
const messaging = getMessaging(app);
const storage = getStorage(app);

onMessage(messaging, (payload) => {
  console.log('📩 前景收到推播：', payload);

  

  const notify_type_id = parseInt(payload.data?.notify_type_id);
  let defaultUrl = "/notify/message"
  if ( notify_type_id === 0 ){
      defaultUrl = "/notify/post"
  }
  const order_sn_id = payload.data?.order_sn_id !== "" ? parseInt(payload.data?.order_sn_id) : null;

  // 判斷要導向的網址
  const targetPath = (notify_type_id === 1 || notify_type_id === 2) && order_sn_id !== null
    ? `/denture-order/detail/${order_sn_id}`
    : defaultUrl;

  const title = payload.data?.title || '新通知';
  const options = {
    body: payload.data?.body || '',
    icon: '/image/dcp-notification-icon.png',
    data: {
      url: targetPath
    }
  };

  if (Notification.permission === 'granted') {
    const notification = new Notification(title, options);

    notification.onclick = (event) => {
      event.preventDefault();
      const fullUrl = new URL(options.data.url, window.location.origin).href;
      window.open(fullUrl, '_blank');
    };
  } else {
    console.warn('⚠️ 使用者尚未允許通知權限，無法顯示');
  }
});


const initFcmServiceWorker  = function(callback=null){
  
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register(`/firebase-messaging-sw.js`).then((registration) => {
      console.log('Service Worker registered with scope:', registration.scope);

      // ✅ 必須同時提供 vapidKey 與 serviceWorkerRegistration 才能成功拿 token
      getToken(messaging, {
        vapidKey: vapidKey,
        serviceWorkerRegistration: registration
      }).then((currentToken) => {
        if (currentToken) {
          localStorage.setItem('currentToken' , currentToken)
          if (!callback){
            return
          }
          callback(currentToken)
          // ApiService.users.upDateFcmToken()

        } else {
          console.log('No registration token available. Request permission to generate one.');
        }
      })
      .catch((err) => {
        console.error('An error occurred while retrieving token: ', err);
      });

    }).catch((err) => {
      console.error('Service Worker registration failed:', err);
    });
  }
}

export { app, messaging, storage , initFcmServiceWorker };
